import { Component, OnInit, Input } from '@angular/core';
import { NotaCredito } from '../../../models/nota-credito';
import { NotaCreditoService } from '../../../services/nota-credito.service';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ProductoService } from '../../../services/producto.service';

@Component({
  selector: 'app-notacredito-modal',
  templateUrl: './notacredito-modal.component.html',
  styleUrls: ['./notacredito-modal.component.css'],
  providers: [NotaCreditoService, ProductoService]
})
export class NotacreditoModalComponent implements OnInit {
  @Input() nota_credito_id: String;
  public nota: NotaCredito;
  public loading = false;

  constructor(
      private notaService: NotaCreditoService,
      public bsModalRef: BsModalRef,
  ){
      this.nota = new NotaCredito();
  }

  ngOnInit(){
      this.getNotaCreditoById();
  }

  getSubtotal(subtotal_iva12, subtotal_iva0){
    return parseFloat(subtotal_iva12) + parseFloat(subtotal_iva0);
  }

  getNotaCreditoById(){
      this.loading = true;
      let qs = '?embed=tipocomprobante,detalle?embed=producto,caja,estadobitacora,venta?embed=cliente;bodega';
      this.notaService.getById(this.nota_credito_id, qs).subscribe(
          res => {
              this.loading = false;
              this.nota = res.data;
          },
          err => {
              this.loading = false;
          }
      );
  }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/notacredito-modal/notacredito-modal.component.ts